var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _circle, _rect7, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriverDetailsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 47,
    viewBox: "0 0 58 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.814209,
    width: 58,
    height: 35,
    rx: 6,
    fill: "url(#paint0_linear_682_14727)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.25,
    y: 3.06421,
    width: 53.5,
    height: 30.5,
    rx: 5.75,
    fill: "url(#paint1_linear_682_14727)",
    stroke: "#E0E0E0",
    strokeWidth: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 9.81421,
    width: 22,
    height: 3,
    rx: 1.5,
    fill: "#494949"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 14.9998,
    width: 18,
    height: 3,
    rx: 1.5,
    fill: "#494949"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 19.8142,
    width: 22,
    height: 3,
    rx: 1.5,
    fill: "#494949"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 27.8142,
    width: 7,
    height: 3,
    rx: 1.5,
    fill: "#494949"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 12.3142,
    r: 4.5,
    fill: "#494949"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 17.8142,
    width: 15,
    height: 7,
    rx: 3.5,
    fill: "#494949"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_682_14727)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 30,
    cy: 43.3142,
    rx: 13,
    ry: 1.5,
    fill: "#D9D9D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_682_14727",
    x: 15,
    y: 39.8142,
    width: 30,
    height: 7,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_682_14727"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_682_14727",
    x1: 1.19901e-7,
    y1: 6.49976,
    x2: 56,
    y2: 33.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_682_14727",
    x1: 2,
    y1: 7.84998,
    x2: 53.096,
    y2: 34.2256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3F3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverDetailsIcon);
export default __webpack_public_path__ + "static/media/driver_details_icon.ebd932d2ba5422c5726171982dd264d8.svg";
export { ForwardRef as ReactComponent };